import { createAdminResource } from 'lib/admin-kit';
import dealerConfig from './config';

/**
 * Registered as 'pages/admin/dealers/Show' by react-rails via:
 *   require.context('components', true)
 *
 * Mounted from app/views/admin_kit/dealers/show.html.haml with props:
 *   record  {object}  Serialized dealer from AdminKit::DealersController#show
 */
export default createAdminResource(dealerConfig).Show;
